<template>
  <div>
    <div class="flex flex-col md:flex-row pb-4 px-20">
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <img :src="song.cover" width="200px" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Song Name</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <p>{{ song.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Category</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <p>{{ song.genre }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Year</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <p>{{ song.year }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">File Song</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <audio controls :src="song.file" controlsList="nodownload" type="audio/mp3" preload="none" >
              Audio tag not supported
            </audio>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Language</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <p>{{ languages }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Copyright</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            <a :href="song.copyright" target="_blank" v-if="!!song.copyright"
              class="underline font-bold"
            >Copyright Link</a>
            <p v-else>-</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Subscription</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            {{song.is_subscription?'Yes':'No'}}
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
      <div class="w-64 font-bold h-6 mx-2 mt-3 text-gray-800">Song Price (USD)</div>
      <div class="flex-1 flex flex-col md:flex-row">
        <div class="w-full flex-1 mx-2">
          <div class="my-2 p-1 flex">
            {{ song.price == 0 ? 'Free' : '$ '+`${parseFloat(toDollar(song.price)).toFixed(2)}` }}
            &nbsp;&nbsp; = {{ parseFloat(song.price).toFixed(2) }} Credits
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpersMixin from '../../mixins/helpers.mixins';

export default {
  name: 'SongDetail',
  mixins: [helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    song: {
      type: Object,
      default: () => ({
        cover: '',
        title: '',
        genre: '',
        year: '',
        file: '',
        language: '',
        copyright: '',
      }),
    },
  },
  data() {
    return {
      languages: '',
      dataLanguages: [],
    };
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  watch: {
    song: {
      immediate: true,
      handler(val) {
        const findLang = this.dataLanguages.find(lang => lang.value == val.language);
        this.languages = findLang != undefined ? findLang.label : '-';
      },
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/contents/SongDetail.vue